import { render, staticRenderFns } from "./DemoChronology.vue?vue&type=template&id=10b5df72&scoped=true&"
import script from "./DemoChronology.vue?vue&type=script&lang=js&"
export * from "./DemoChronology.vue?vue&type=script&lang=js&"
import style0 from "./DemoChronology.vue?vue&type=style&index=0&id=10b5df72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5df72",
  null
  
)

export default component.exports